import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Bandeau affiche en haut de l'app si :
 * - tenant en essai (computed_status='trial')   -> info ambre
 * - moins de 2 jours restants                    -> alerte rose
 * - tenant expired                               -> bandeau bloquant rouge (rare car login bloque deja)
 */
export default function TrialBanner() {
  const { user } = useAuth();
  const tenant = user?.tenant;
  if (!tenant) return null;

  const status = tenant.computed_status;
  if (status === 'active') return null;

  // Calcul jours restants
  let daysLeft = null;
  let endDate = null;
  if (status === 'trial' && tenant.trial_ends_at) {
    endDate = new Date(tenant.trial_ends_at);
    daysLeft = Math.max(0, Math.ceil((endDate - new Date()) / (1000 * 60 * 60 * 24)));
  }

  if (status === 'trial') {
    const urgent = daysLeft !== null && daysLeft <= 2;
    return (
      <div
        data-testid="trial-banner"
        className={`px-4 py-2 text-center text-sm font-medium ${
          urgent
            ? 'bg-gradient-to-r from-orange-500 to-orange-600 text-white'
            : 'bg-gradient-to-r from-blue-600 via-blue-500 to-orange-500 text-white'
        }`}
      >
        {urgent
          ? `⚠️ Votre essai TripNova expire ${daysLeft === 0 ? "aujourd'hui" : `dans ${daysLeft} jour${daysLeft > 1 ? 's' : ''}`} — `
          : `🎁 Essai TripNova en cours — ${daysLeft} jour${daysLeft > 1 ? 's' : ''} restant${daysLeft > 1 ? 's' : ''}. `}
        <a
          href="/billing"
          data-testid="trial-banner-cta"
          className="underline font-bold ml-1"
        >
          Activer mon abonnement
        </a>
      </div>
    );
  }

  if (status === 'expired') {
    return (
      <div data-testid="trial-banner-expired" className="px-4 py-2 text-center text-sm font-bold bg-rose-600 text-white">
        🔒 Abonnement expiré — certaines fonctions sont bloquées.{' '}
        <a href="/billing" className="underline">Renouveler maintenant</a>
      </div>
    );
  }

  return null;
}
